<template>
    <!--弹窗-->
    <el-dialog
        width="600px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <div v-loading="disabled">
            <div style="height: 250px !important;">
                <div class="top">
                    <div style="font-weight: 900;">下载模板</div>
                    <div style="margin-left: 90px;">
                        <a
                            href="/export/断货分析箱规模板.xlsx"
                            style="text-decoration: underline; color: rgb(58, 142, 230);"
                            >点击下载“断货分析箱规”模板</a
                        >
                    </div>
                </div>
                <div class="download">
                    <el-upload
                        class="upload-demo"
                        drag
                        action="/"
                        :file-list="fileList"
                        :on-change="handleChange"
                        :on-remove="handleRemove"
                        :auto-upload="false"
                        multiple
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                            将文件拖到此处，或<em>点击上传</em>
                        </div>
                        <div
                            class="el-upload__text"
                            style="font-size: 12px;margin-top: 5px;"
                        >
                            只能上传.xls/.xlsx文件
                        </div>
                    </el-upload>
                </div>
            </div>
            <el-row style="margin-top:17px; ">
                <el-button
                    style="float:right;margin-left:6px;"
                    size="mini"
                    plain
                    @click="handleClose(true)"
                    >取 消</el-button
                >
                <el-button
                    style="float:right"
                    size="mini"
                    type="primary"
                    @click="accountForm()"
                    :loading="disabled"
                    >确定</el-button
                >
            </el-row>
        </div>
    </el-dialog>
</template>
<script>
    import * as api from '@/api/advAnalys/advAnalys'
export default {
    data() {
        return {
            fileList: [],
            disabled: false,
            filesize: 0,
            file_data: null
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        us_arr: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        //上传Excel文件的处理方法
        handleChange(file, fileList) {
            if (fileList.length > 1) {
                this.fileList = [fileList[fileList.length - 1]];
            }
            this.fileTemp = file.raw;
            let extend = this.fileTemp.name.substring(
                this.fileTemp.name.lastIndexOf("."),
                this.fileTemp.name.length
            );
            if (this.fileTemp) {
                if (extend == ".xlsx" || extend == ".xls" || extend == ".csv") {
                    this.file_data = this.fileTemp;
                    this.filesize = this.fileTemp.size;
                } else {
                    this.$message({
                        type: "warning",
                        message: "附件格式错误，请删除后重新上传!"
                    });
                }
            } else {
                this.$message({
                    type: "warning",
                    message: "请上传附件!"
                });
            }
        },
        //超过上载文件的最大数量限制如何删除文件
        handleRemove() {
            this.fileList = [];
            this.fileTemp = null;
            this.file_data = null;
        },
        accountForm() {
            if (this.file_data == null) {
                this.$message({
                    type: "error",
                    message: "请上传符合格式数据文件！"
                });
                return;
            }
            if (this.filesize / 1024 / 1024 > 10) {
                this.$message({
                    type: "error",
                    message: "请上传小于10MB 的数据！"
                });
                return;
            }
            if (this.filesize / 1024 / 1024 > 1) {
                this.$notify.info({
                    title: "提示",
                    message: "文件过大，数据处理大约需要1~2分钟",
                    duration: 30000
                });
            }
            var file = new FormData();
            file.append("file", this.file_data);

            // file.append("file", this.files[0]);

            console.log('file', file)
            this.disabled = true;
            api.out_of_stock_analysis_import_box_specification(file)
                .then(res => {
                    if (res.code === 0) {
                        this.$message({
                            message: "导入成功",
                            type: "success"
                        });
                        this.disabled = false;
                        this.handleClose(false);
                    } else {
                        this.disabled = false;
                        this.$message({
                            message: res.message,
                            type: "error"
                        });
                    }
                })
                .catch(() => {
                    this.disabled = true;
                });
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.handleRemove();
            this.$emit("close-callback", isshow);
            this.disabled = false;
        }
    }
};
</script>
<style type="text/scss" lang="scss">
.download {
    display: flex;
    justify-content: center;
}
.top {
    margin: 0px auto;
    width: 60%;
    margin-bottom: 20px;
    display: flex;
}
</style>
